import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

import { fieldProps } from "./field.composable";
import Message from "@/components/common/Message.vue";
import { getMessage } from "@/core/validation";


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldItems',
  props: {
  ...fieldProps
},
  emits: ["add-item", "remove-item"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const add = () => {
  emit("add-item");
};
const remove = () => {
  emit("remove-item");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["field field-items", [
      { invalid: props.validation.$invalid && props.validation.$dirty },
      props.styling
    ]])
  }, [
    (!props.hideLabel)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (
          props.validation &&
          props.validation.$invalid &&
          !props.validation.$dirty
        )
            ? (_openBlock(), _createElementBlock("sup", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("button", {
      type: "button",
      class: "btn icononly",
      onClick: add
    }, _hoisted_4),
    _createVNode(Message, {
      type: "alert",
      styling: props.messageStyling,
      message: _unref(getMessage)(props.validation),
      show: props.validation.$invalid && props.validation.$dirty,
      onDismiss: _cache[0] || (_cache[0] = ($event: any) => (props.validation.$reset()))
    }, null, 8, ["styling", "message", "show"])
  ], 2))
}
}

})